@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let largeScreen = largeScreen$ | async;

<div id="video-editing" [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    <h1>{{ "video_editing.title" | translate | autoCapitalize}}</h1>

    <header>
        {{ 'languages.french' | translate | titlecase }} {{ 'common.to'| translate }} {{ 'languages.english'| translate
        | titlecase }}
        <div class="subtitle">{{ "video_editing.subtitle" | translate }}</div>
    </header>

    <div class="content">

        <section>
            <div class="settings">
                <form [formGroup]="audioForm" (ngSubmit)="complete()">
                    <div class="audio-settings">
                        <div class="audio-setting" (submit)="complete()">
                            @let originalVolumeValue = audioForm.controls['originalVolume'].value;
                            <label for="original-volume">
                                <lucide-icon size="20" [name]=" originalVolumeValue > 0 ? 'volume2' : 'volume-x' " />
                                {{ 'video_editing.form.original_voices_level.label' | translate }}</label>
                            <input formControlName="originalVolume" type="range" step="0.01" id="original-volume"
                                name="original-volume" min="0" max="1">
                            <p class="tips">{{ ('video_editing.form.original_voices_level.tips' |
                                translate).replace('{sourceLang}', ('languages.'+ (job$ | async)?.LangFrom?.name) |
                                translate) }}</p>
                            @if(assetsLoaded){
                            <audio step="0.01" class="audioPlayer" #audioVocal [volume]="originalVolumeValue">
                                <source [src]="vocalsUrl" type="audio/wav">
                            </audio>
                            }
                        </div>
                        <div class="audio-setting">
                            @let translationVolumeValue = audioForm.controls['translationVolume'].value;
                            <label for="translation-volume"><lucide-icon size="20"
                                    [name]="translationVolumeValue > 0 ? 'volume2' : 'volume-x'" />{{
                                'video_editing.form.translated_voices_level.label' | translate }}</label>
                            <input formControlName="translationVolume" type="range" step="0.01" id="translation-volume"
                                name="translation-volume" min="0" max="1">
                            <p class="tips">{{ ('video_editing.form.translated_voices_level.tips' |
                                translate).replace('{targetLang}', ('languages.'+ (job$ | async)?.LangTo?.name) |
                                translate) }}</p>
                            @if(assetsLoaded){
                            <audio step="0.01" class="audioPlayer" #audioTranslated [volume]="translationVolumeValue">
                                <source [src]="translatedAudioUrl" type="audio/wav">
                            </audio>
                            }

                        </div>
                        <div class="audio-setting">
                            @let soundVolumeValue = audioForm.controls['musicVolume'].value;
                            <label for="music-volume"><lucide-icon size="20"
                                    [name]="soundVolumeValue > 0 ? 'volume2' : 'volume-x'" />{{
                                'video_editing.form.muscic_and_sounds_level.label' | translate }}</label>
                            <input formControlName="musicVolume" type="range" step="0.01" id="music-volume"
                                name="music-volume" min="0" max="1">
                            <p class="tips">{{ 'video_editing.form.muscic_and_sounds_level.tips' | translate }}</p>
                            @if(assetsLoaded){
                            <audio step="0.01" class="audioPlayer" #audioMusic [volume]="soundVolumeValue">
                                <source [src]="musicUrl" type="audio/wav">
                            </audio>
                            }

                        </div>
                    </div>
                    <app-button type="submit">{{ 'video_editing.form.buttons.finalize' | translate }}</app-button>
                </form>
            </div>
        </section>

        @if(assetsLoaded){
        <section class="video-player">
            <video #videoPlayer [muted]="true" preload="metadata">
                <source [src]="videoCleanUrl" />
            </video>
            <!-- ? dans un premier temps on va laisser les controles du player video -->
            <div class="controls">
                <div class="control-btn" (click)="play()">
                    @if(isPlaying){
                    <lucide-icon size="20" name="pause" />
                    }@else {
                    <lucide-icon size="20" name="play" />
                    }
                </div>
                <div class="control-btn" (click)="stop()">
                    <lucide-icon size="20" name="square" />
                </div>
                <input #progressBar class="progress-bar" type="range" [value]="0" name="" id="">
            </div>
        </section>
        } @else {
        <div class="video-player-loading">
            <ng-lottie [options]="{ path: '/assets/animations/svet-loader.json'}" [height]="'200px'" />
        </div>
        }
    </div>

</div>